import BaseModel from '../base';

export default class Criterian extends BaseModel {
  constructor(criterian, url) {
    super(criterian, url);

    this.name = criterian.name;
    this.max_score = criterian.max_score;
    this.description = criterian.description;
  }
}
